import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { getAutoridades } from "../../service/apiBackEnd.js";
import styles from "../index.module.css"
const Autoridades = () => {
    const [autoridades, setAutoridades] = useState([]);

    
    useEffect(() => {
        const fetchPosts = async () => {
            const data = await getAutoridades();
            const sortedData = data.sort((a, b) => new Date(a.date) - new Date(b.date));
            setAutoridades(sortedData);
        };
        fetchPosts();
    }, []);

    console.log("autoridades", autoridades);

    return (
        <Container>
            <Row>
                <Col lg={12} className="mb-5 mt-5">
                    <h1>Autoridades</h1>                   
                </Col>
                {autoridades.map((autoridad) => {
                    const featuredImage =
                        autoridad._embedded?.['wp:featuredmedia']?.[0]?.source_url || 'default-image.jpg';

                    return (
                        <Col lg={4} md={6} sm={12} key={autoridad.id} className="mb-3">
                        <div className={styles.autoridades}>
                            {featuredImage && <img src={featuredImage} className={styles.imgStaff} alt={autoridad.title.rendered} />}
                            <h5>{autoridad.title.rendered}</h5>
                            <hr></hr>
                            <p dangerouslySetInnerHTML={{ __html: autoridad.excerpt.rendered }}></p>
                            </div>
                        </Col>
                    );
                })}
            </Row>
        </Container>
    );
};

export default Autoridades;
